/**
 * Punkt 149: Formularregeln für „Passwort setzen“. Das Passwort selbst verlässt diese Funktionen nie.
 * Grenzen wie der Server (apps/api/src/routes/members.ts, passwortSchema): 8 bis 70 Zeichen.
 */
export const PASSWORT_MIN = 8;
export const PASSWORT_MAX = 70;

const LABEL = ["Zu schwach", "Zu schwach", "Geht so", "Gut", "Stark"] as const;

/** 0–4: Länge ≥ 8, Länge ≥ 12, Groß- und Kleinbuchstaben, Ziffer oder Sonderzeichen. */
export function staerke(pw: string): number {
  if (pw.length < PASSWORT_MIN) return 0;
  let s = 1;
  if (pw.length >= 12) s++;
  if (/[a-zäöüß]/.test(pw) && /[A-ZÄÖÜ]/.test(pw)) s++;
  if (/[^A-Za-zÄÖÜäöüß]/.test(pw)) s++;
  return Math.min(s, 4);
}

export function staerkeLabel(pw: string): string {
  return LABEL[staerke(pw)]!;
}

/** Zeile unter dem Stärkebalken. */
export function staerkeHinweis(pw: string): string {
  if (pw.length < PASSWORT_MIN) return `Mindestens 8 Zeichen. Es fehlen noch ${PASSWORT_MIN - pw.length}.`;
  if (pw.length > PASSWORT_MAX) return `Höchstens 70 Zeichen. ${pw.length - PASSWORT_MAX} zu viel.`;
  return `${staerkeLabel(pw)}. Mindestens 8 Zeichen.`;
}

export function darfWeiter(pw: string, wdh: string): boolean {
  return pw.length >= PASSWORT_MIN && pw.length <= PASSWORT_MAX && pw === wdh;
}

const WOERTER = [
  "Basilikum", "Tomate", "Olive", "Zitrone", "Rosmarin", "Salbei", "Trüffel", "Feige", "Mandel",
  "Pinie", "Espresso", "Ricotta", "Fenchel", "Kapern", "Orange", "Pfirsich", "Kastanie", "Lorbeer",
  "Minze", "Thymian", "Oregano", "Safran", "Pistazie", "Walnuss", "Birne", "Kirsche", "Melone",
] as const;

function zufall(n: number): number {
  const a = new Uint32Array(1);
  crypto.getRandomValues(a);
  return a[0]! % n;
}

/** Drei Wörter mit Bindestrich plus zweistellige Zahl, z. B. „Salbei-Feige-Olive-42“. */
export function vorschlag(): string {
  const w = [0, 1, 2].map(() => WOERTER[zufall(WOERTER.length)]!);
  return `${w.join("-")}-${10 + zufall(90)}`;
}
